import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=656d5e9a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=656d5e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d5e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656d5e9a')) {
      api.createRecord('656d5e9a', component.options)
    } else {
      api.reload('656d5e9a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=656d5e9a&scoped=true&", function () {
      api.rerender('656d5e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4TWBw0fvk4dfd/JS/comp/GuestBox.vue"
export default component.exports